import { createAction, createRequestActions } from "common/helpers/action";

// Authorize
export const initSignIn = createAction("AUTH.INIT_SIGN_IN");
export const sendSignIn = createRequestActions("AUTH.SEND_SIGN_IN");

// Forgot
export const sendForgot = createRequestActions("AUTH.SEND_FORGOT");
